import { LeaderboardEntry, MatsnetLeaderboardEntry } from "@mezo/api"
import { Block, Button, HeadingLarge } from "@mezo-org/mezo-clay"

import { LeaderboardProps } from "#/shared/types"

import LeaderboardContent from "./LeaderboardContent"

export default function LeaderboardTable({
  leaderboard,
  isLeaderboardFullyFetched,
  loadMore,
  currentUserRank,
  isMatsLeaderboard = false,
}: LeaderboardProps<MatsnetLeaderboardEntry | LeaderboardEntry> & {
  isMatsLeaderboard?: boolean
}) {
  return (
    <>
      <HeadingLarge marginBottom="scale900">Standing</HeadingLarge>
      <LeaderboardContent
        leaderboard={leaderboard}
        isMatsLeaderboard={isMatsLeaderboard}
        currentUserRank={currentUserRank}
      />
      {!isLeaderboardFullyFetched && (
        <Block
          display="flex"
          width="100%"
          justifyContent="center"
          marginTop="scale1000"
        >
          <Button
            onClick={loadMore}
            shape="pill"
            kind="secondary"
            size="medium"
          >
            Load more
          </Button>
        </Block>
      )}
    </>
  )
}
